/**
 * 008 · US1 (cierre del deadline) — Aviso de "plazo cerrado" para el invitado que llega tarde.
 * Deshabilita el RSVP y ofrece un botón para escribirle por WhatsApp al/la coordinador/a de la
 * boda (configurado en "Mi boda"). El texto deja claro que hay una coordinación por detrás.
 */
interface RsvpCerradoProps {
  coordinadorUrl?: string;
  coordinadorNombre?: string | null;
}

export default function RsvpCerrado({ coordinadorUrl, coordinadorNombre }: RsvpCerradoProps) {
  return (
    <div style={{ textAlign: 'center', padding: '24px', maxWidth: 480, margin: '0 auto' }}>
      <p style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
        El plazo para confirmar ya cerró
      </p>
      <p style={{ opacity: 0.8, marginBottom: 16, lineHeight: 1.5 }}>
        La fecha límite para confirmar asistencia ya pasó. Si aún necesitas coordinar tu
        asistencia,{' '}
        {coordinadorNombre
          ? `escríbele a ${coordinadorNombre}, que coordina la boda,`
          : 'escríbele a quien coordina la boda'}{' '}
        y con gusto te ayudará.
      </p>
      {coordinadorUrl && (
        <a
          href={coordinadorUrl}
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'inline-block',
            padding: '10px 22px',
            borderRadius: 999,
            background: '#25D366',
            color: '#fff',
            textDecoration: 'none',
            fontWeight: 600,
          }}
        >
          Escribir por WhatsApp
        </a>
      )}
    </div>
  );
}
